export const server = {
  baseURL: "https://resources-lib.gestaltarchive.com",
  // baseURL: "http://localhost:3000",
};
